
import Vue from "vue";
import {imamHussainAPI, hazratMassomehAPI} from "@/api";
import {HolyShrineType} from "@/enums/holy-shrine-type";

export default Vue.extend({
  name: "inquiry-details",

  components: {},
  data() {
    return {
      data: [],
      loading: false
    };
  },
  mounted() {

    const type = this.$route.params.type;

    if (type == HolyShrineType.ImamHussain) {
      this.loading = true;
      imamHussainAPI
          .ziaratInquiry({cellphone: this.$route.params.id})
          .then((res) => {
            let data = res.data?.data || [];
            this.data = data.map(item => {
              item.title = "حرم امام حسین (ع)";
              item.icon = require("@/assets/img/svg/imam-hussain-logo.svg");
              item.statusTitle = this.setStatusTitle(item.status);
              item.cssClass = this.setStatusStyle(item.status);
              return item;
            })
          })
          .finally(() => {
            this.loading = false;
          });

    } else if (type == HolyShrineType.HazratMassomeh) {
      this.loading = true;
      hazratMassomehAPI
          .ziaratInquiry({cellphone: this.$route.params.id})
          .then((res) => {
            let data = res.data?.data || [];
            this.data = data.map(item => {
              item.title = "حرم حضرت معصومه (س)";
              item.icon = require("@/assets/img/svg/hazrat-masoomeh-logo.svg");

              item.statusTitle = this.setStatusTitle(item.status);
              item.cssClass = this.setStatusStyle(item.status);
              return item;
            })
          })
          .finally(() => {
            this.loading = false;
          });

    }
  },
  methods: {
    setStatusStyle(status) {
      switch (status) {
        case 'DONE':
          return 'status__done';
        default:
          return 'status__pending';
      }
    },
    setStatusTitle(status) {
      switch (status) {
        case 'DONE':
          return 'زیارت انجام شده';
        default:
          return 'در انتظار زیارت';
      }
    },
    handleNewInquiry() {
      this.$router.push({name: "home"})
    }
  },
});
